import { render } from "./OfferPopup.vue?vue&type=template&id=45dd3543&scoped=true"
import script from "../js/offer-popup.js?vue&type=script&lang=js"
export * from "../js/offer-popup.js?vue&type=script&lang=js"

import "./OfferPopup.vue?vue&type=style&index=0&id=45dd3543&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45dd3543"]])

export default __exports__